import { AddressDto, agencyStatusValues, statusValues as agency_status_values, status as agency_status } from "./agency";

export interface Response<T>{
    success: boolean,
    content: {
        totalElements: number;
        totalCompaniesCount: number;
        data: T;
    },
    returnCode: number,
    errorMessage?: string
}

export interface PhoneDto {
    countryCode: string;
    number: string
}

export interface Company {
    id?: string;
    logo: string;
    name: string;
    status: string;
    phoneNumber: PhoneDto;
    fax: PhoneDto;
    email: string;
    address: AddressDto;
    createdAt: Date;
    createdBy: string;
    nonMDMCustomer?: string;
}

export interface CompanyId {
    companyId?: string;
}

export const companyStatusValues = agencyStatusValues

export const statusValues = agency_status_values

export const status = agency_status
export const defaultSelectedCompanyRows = [
    'Company',
    'Email',
    'Phone',
    'Status'
  ]
  export const CompanyyListingRows = [
    {value: 'Company', label: 'Company'},
    {value: 'Email', label: 'Email'},
    {value: 'Phone', label: 'Phone'},
    {value: 'Status', label: 'Status'},
  ];

export const CompanyUserRegistrationType = [
  { value: 'notSet', label: 'Not Set'},
  { value: 'enabled', label: 'Enabled'},
  { value: 'disabled', label: 'Disabled'}
];

export enum CompanyUserRegistrationTypeEnum {
  NotSet = 'notSet',
  Enabled = 'enabled',
  Disabled = 'disabled'
}

export enum NonMDMCustomerEnum {
  NotSet = 'notSet',
  Enabled = 'enabled',
  Disabled = 'disabled'
}

export const rotationSetOptions = [
  { value: true, label: 'Enable'},
  { value: false, label: 'Disable'}
];

// Backend accepts: notSet | enabled | disabled
export const nonMdmCustomerOptions = [
  { value: NonMDMCustomerEnum.NotSet, label: 'Not Set' },
  { value: NonMDMCustomerEnum.Enabled, label: 'Enable' },
  { value: NonMDMCustomerEnum.Disabled, label: 'Disable' }
];

export const rotationDurationOptions = [
  {
    value: 30,
    label: '30 Days'
  },
  {
    value: 60,
    label: '60 Days'
  },
  {
    value: 90,
    label: '90 Days'
  },
  {
    value: 120,
    label: '120 Days'
  },
  {
    value: 150,
    label: '150 Days'
  },
  {
    value: 180,
    label: '180 Days'
  },
  {
    value: 210,
    label: '210 Days'
  }
]

export const deleteReportDaysOptions = [
  {
    value: 1,
    label: '1 Day'
  },
  {
    value: 2,
    label: '2 Days'
  },
{
    value: 3,
    label: '3 Days'
},
  {
    value: 4,
    label: '4 Days'
  },
  {
    value: 5,
    label: '5 Days'
  },
  {
    value: 6,
    label: '6 Days'
  },
  {
    value: 7,
    label: '7 Days'
  },
  {
    value: 8,
    label: '8 Days'
  },
  {
    value: 9,
    label: '9 Days'
  },
  {
    value: 10,
    label: '10 Days'
  },
  {
    value: 11,
    label: '11 Days'
  },
  {
    value: 12,
    label: '12 Days'
  },
  {
    value: 13,
    label: '13 Days'
  },
  {
    value: 14,
    label: '14 Days'
  },
  {
    value: 15,
    label: '15 Days'
  },
  {
    value: 20,
    label: '20 Days'
  },
  {
    value: 25,
    label: '25 Days'
  },
  {
    value: 30,
    label: '30 Days'
  }

]
